import React from "react";
import PropTypes from "prop-types";

const PanelStat = React.createContext();

class Panel extends React.Component {
    constructor(props) {
        super(props);

        this.toggleExpand = () => {
            this.setState(() => ({
                expand: !this.state.expand,
            }));
            if (this.props.onChangeSize) this.props.onChangeSize();
        };
        this.toggleRemove = () => {
            this.setState(() => {
                if (this.props.onClose) this.props.onClose();
                return {
                    remove: !this.state.remove,
                };
            });
        };

        this.toggleCollapse = () => {
            this.setState(() => ({
                collapse: !this.state.collapse,
            }));
            if (this.props.onChangeSize) this.props.onChangeSize();
        };

        this.toggleReload = () => {
            if (this.state.reload !== true) {
                this.setState(() => ({
                    reload: true,
                }));

                setTimeout(() => {
                    this.setState(() => ({
                        reload: false,
                    }));
                }, 2000);
            }
        };

        this.state = {
            expand: false,
            collapse: false,
            reload: false,
            remove: false,
            toggleExpand: this.toggleExpand,
            toggleReload: this.toggleReload,
            toggleRemove: this.toggleRemove,
            toggleCollapse: this.toggleCollapse,
        };
    }

    render() {
        let stylePanel = this.props.stylePanel ? this.props.stylePanel : {};
        return (
            <PanelStat.Provider value={this.state}>
                {!this.state.remove && (
                    <div
                        style={stylePanel}
                        className={
                            "panel panel-" +
                            (this.props.theme ? this.props.theme : "inverse") +
                            " " +
                            (this.state.expand ? "panel-expand " : " ") +
                            (this.state.reload ? "panel-loading " : " ") +
                            (this.props.className ? this.props.className : "")
                        }
                    >
                        {this.props.children}
                    </div>
                )}
            </PanelStat.Provider>
        );
    }
}

class PanelHeader extends React.Component {
    render() {
        return (
            <div className="panel-heading">
                <h4 className="panel-title">{this.props.children}</h4>
                {!this.props.noButton && (
                    <PanelStat.Consumer>
                        {({
                            toggleExpand,
                            toggleRemove,
                            toggleCollapse,
                            toggleReload,
                            collapse,
                        }) => (
                            <div className="panel-heading-btn">
                                {!this.props.noExpand && (
                                    <button
                                        className="btn btn-xs btn-icon btn-circle btn-default"
                                        onClick={toggleExpand}
                                    >
                                        <i className="fa fa-expand"></i>
                                    </button>
                                )}
                                &nbsp;&nbsp;
                                {!this.props.noRefresh && (
                                    <button
                                        className="btn btn-xs btn-icon btn-circle btn-success"
                                        onClick={toggleReload}
                                    >
                                        <i className="fa fa-redo"></i>
                                    </button>
                                )}
                                &nbsp;&nbsp;
                                {!this.props.noMinimize && (
                                    <button
                                        className="btn btn-xs btn-icon btn-circle btn-warning"
                                        onClick={toggleCollapse}
                                    >
                                        <i
                                            className={
                                                !collapse
                                                    ? "fa fa-minus"
                                                    : "fa fa-plus"
                                            }
                                        />
                                    </button>
                                )}
                                &nbsp;&nbsp;
                                {!this.props.noRemove && (
                                    <button
                                        className="btn btn-xs btn-icon btn-circle btn-danger"
                                        onClick={toggleRemove}
                                    >
                                        <i className="fa fa-times"></i>
                                    </button>
                                )}
                            </div>
                        )}
                    </PanelStat.Consumer>
                )}
            </div>
        );
    }
}

class PanelBody extends React.Component {
    render() {
        return (
            <PanelStat.Consumer>
                {({ collapse, reload }) => (
                    <div
                        className={
                            "panel-body " +
                            (collapse ? "d-none " : " ") +
                            this.props.className
                        }
                    >
                        {this.props.children}

                        {reload && (
                            <div className="panel-loader">
                                <span className="spinner-small"></span>
                            </div>
                        )}
                    </div>
                )}
            </PanelStat.Consumer>
        );
    }
}

class PanelFooter extends React.Component {
    render() {
        return (
            <div className={"panel-footer " + this.props.className}>
                {this.props.children}
            </div>
        );
    }
}

PanelHeader.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    noRemove: PropTypes.bool,
    noButton: PropTypes.bool,
    noExpand: PropTypes.bool,
    noRefresh: PropTypes.bool,
    noMinimize: PropTypes.bool,
};

PanelBody.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};

PanelFooter.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};

Panel.propTypes = {
    onChangeSize: PropTypes.func,
    onClose: PropTypes.func,
    stylePanel: PropTypes.string,
    className: PropTypes.string,

    children: PropTypes.any,
    theme: PropTypes.string,
};

export { Panel, PanelHeader, PanelBody, PanelFooter };
